import * as React from "react";
import DateRangeModal from "../misc/components/queryTable/DateRangeModal";
import { Query, QueryFilter, AuditTrailEvent, QueryCondition } from "../misc/api/apiTypes";

export const EventDateTimeFilterMember = "EventDateTime";
export const EventDateTimeHeader = "Date Time";

interface EventDateTimeFilterModalProps {
    onApply: (from: QueryFilter, to: QueryFilter) => void;
    onClose: () => void;
    query: Query<AuditTrailEvent>;
}

const GetFromQueryFilter = (query: Query<AuditTrailEvent>): QueryFilter => {
    return query.Filters.find(
        filter =>
            filter.Member === EventDateTimeFilterMember &&
            filter.Condition === QueryCondition.GreaterThanOrEqual
    );
};

const GetToQueryFilter = (query: Query<AuditTrailEvent>): QueryFilter => {
    return query.Filters.find(
        filter =>
            filter.Member === EventDateTimeFilterMember &&
            filter.Condition === QueryCondition.LessThanOrEqual
    );
};

const EventDateTimeFilterModal = ({
    onApply,
    query,
    onClose
}: EventDateTimeFilterModalProps): JSX.Element => {
    const fromFilterValue = GetFromQueryFilter(query) || { Values: [] };
    const toFilterValue = GetToQueryFilter(query) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (
        <DateRangeModal
            header={EventDateTimeHeader + " Filter"}
            show={true}
            to={to}
            from={from}
            onChange={(_from, _to) => {
                setFrom(_from);
                setTo(_to);
            }}
            onApply={() => {
                onApply(
                    {
                        Member: EventDateTimeFilterMember,
                        Condition: QueryCondition.GreaterThanOrEqual,
                        Values: !!from ? [from] : []
                    },
                    {
                        Member: EventDateTimeFilterMember,
                        Condition: QueryCondition.LessThanOrEqual,
                        Values: !!to ? [to] : []
                    }
                );
            }}
            onClear={() => {
                onApply(
                    {
                        Member: EventDateTimeFilterMember,
                        Condition: QueryCondition.GreaterThanOrEqual,
                        Values: []
                    },
                    {
                        Member: EventDateTimeFilterMember,
                        Condition: QueryCondition.LessThanOrEqual,
                        Values: []
                    }
                );
            }}
            onClose={onClose}
        />
    );
};

export default EventDateTimeFilterModal;
